import { Text } from '@cmpsr/components';

type ModalIntroWizardStepDescriptionProps = {
  activeStep: number;
};

export default function ModalIntroWizardStepDescription(props: ModalIntroWizardStepDescriptionProps) {
  return renderSwitch(props.activeStep);
}

function renderSwitch(activeStep: number): React.ReactNode {
  switch (activeStep) {
    case 1: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          Based on your responses in the Risk Assessment, we’ve ranked the top diet, lifestyle or other changes that can
          help reduce your cancer risk. Click “see details” for any Action to understand its full impact on cancer risk.
        </Text>
      );
    }
    case 2: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          To build your Action Plan, start by selecting up to 5 actions. You can choose based on their impact on your
          cancer risk or based on what’s most feasible for you right now. Remember, most Actions not only reduce cancer
          risk, but improve overall health as well.
        </Text>
      );
    }
    case 3: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          As you work through the actions in your Action Plan, you can mark them complete. For Actions that involve
          habit change, we recommend you practice the habit for 60 days before marking it complete to cement the long
          term impact.
        </Text>
      );
    }
    case 4: {
      return (
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          As your complete Actions, you will see the impact on your overall Risk Trend. Remember, little changes add up
          over time. The average Catch member can reduce their cancer risk up to 60% through lifestyle changes.
        </Text>
      );
    }
  }
}
